import React from 'react';
import { Helmet } from 'react-helmet-async';
import WallPainter from '../JungleSimulator/WallPainter';
import './MapEditorPage.css';

const MapEditorPage: React.FC = () => {
  return (
    <div className="map-editor-page">
      <Helmet>
        <title>Map Editor – LoL Calculator</title>
      </Helmet>

      <div className="map-editor-header">
        <h1 className="map-editor-title">Map Editor</h1>
        <p className="map-editor-subtitle">
          Paint walls, bushes, turrets, inhibitors, jungle camps, nexus, and spawn zones onto the Summoner's Rift map.
          Export the walkability grid for pathfinding and simulation.
        </p>
      </div>

      <WallPainter />
    </div>
  );
};

export default MapEditorPage;
